export default {
    header: { fullName: 'Business Product Selector' },
    landingPageContent: {
        startPageHeader:
            'Getting started with the Business Product Selector',
        productDescription:
            'Use this tool to ask your client four simple questions. Then you’ll get a list of the best products for their needs. These may include checking, credit cards, loans, treasury management, payment solutions and even online banking services.',
        youWillNeedHeader: 'You’ll need:',
        youWillNeedContent:
            'Information about how your client gets paid and makes payments, so you can answer the questions in this tool.',
        keepInMindHeader: 'Keep in mind:',
        salesProcesstext:
            'You can use this before, during or after a client conversation — whatever works best for your sales process.',
        listOfQuestionstext:
            'It takes just a few minutes to go through the questions.',
        suggestedProductsText:
            'At the end, you’ll get a list of suggested products.',
        emailCopyText:
            'You can save the product list by emailing a copy of it to yourself.',
        productsInfoText:
            'The product list doesn’t include “specialty” products, such as nonprofit checking or co-brand business credit cards.',
        clientRelationshipNameLabel:
            'Before you begin, what’s the client’s relationship name in Salesforce?',
    },
    footer: {
        connectionTitle: 'Connection secured',
        footerDisclosure:
            'We protect your information with encryption, firewalls and other security measures.',
        connectionContent:
            'Products are offered by U.S. Bank National Association. Member FDIC.',
    },
    recommendation: {
        title: 'We have some great options for you.',
        subTitle:
            'These product suggestions are based on your answers. To change answers, you can ',
        subTitleLink: 'start over',
        reviewEditTitle: 'Review and Edit',
        sendEmailHeader: 'Save the suggested products list.',
        sendEmailContent:
            'For the banker: Save this list for your sales records. You can email it to yourself.',
        sendEmailButtonLabel: 'Send email',
        changeHeader: 'Need to make a change for this client?',
        changeAnswerContent:
            'Product suggestions are based on your answers. You can:',
        editExistingAnswer: 'Edit existing answers',
        provideAllAnswer: 'Provide all new answers',
        emailStatusModal: {
            emailProcessingHeader: 'We’re sending your email.',
            emailProcessingBody: 'This will just take a few moments.',
            emailSentHeader: 'We sent the email to ',
            emailSentBody: 'It should arrive in a couple of minutes.',
            emailErrorHeader: 'There was an error on our side.',
            emailErrorBody: 'We’re sorry. Please try again.',
            emailModalCloseButton: 'Close',
        },
    },
    pageToTitleMap: {
        P1Q1: 'What goals do you have',
        P2Q1: 'How do your customers pay',
        P3Q1: 'How do you pay',
        P4Q1: 'Are any of these important',
    },
    errorContent: {
        roleErrorHeading:
            'The Business Product Selector isn’t available.',
        roleErrorDescription:
            'This feature isn’t available for your role yet. Talk to your manager if you have questions.',
    },
    tabsHeader: ['Suggested products', 'All products'],
    siteCat: {
        siteSection: 'tools',
        subSiteSection: 'product selector business banking',
        applyPlatform: 'onboarding',
        startPage: 'getting started with business product selector',
        goalsPage: 'next year business goals',
        receivePayment: 'how do customers pay you',
        makePayment:
            'how do you pay vendors, employees, reimburse customers',
        manageBusiness: 'what helps you manage and run your business',
        suggestedProductsPage: 'we have great options for you',
        changeAnswersFirstLink: 'edit existing answers click',
        defaultTabOption: 'suggested products',
        otherTabOption: 'all products',
        changeAnswersSecondLink: 'provide all new answers click',
        learnMoreLink: 'learn more click',
        featuresLink: 'features click',
        emailLink: 'send email click',
        preparerType: 'banker',
        formState: {
            submit: 'SUBMIT',
            start: 'START',
        },
    },
    prodRecBusinessBankDisclousers: {
        disclosureTitle: 'Disclosures',
        disclosureContent:
            '<span class="disclosureContent">Deposit products are offered by U.S. Bank National Association. Member FDIC.<br/><br/><br/>Credit products offered by U.S. Bank National Association and subject to normal credit approval. <br/><br/><br/>The creditor and issuer of U.S. Bank credit cards is U.S. Bank National Association, pursuant to separate licenses from Visa U.S.A. Inc., MasterCard International Inc., and American Express, federally registered service mark of American Express.<br/><br/><br/>For additional information call 855-955-2760 or visit your local branch for a copy of Business Pricing Information disclosure or refer to Your Deposit Account Agreement (YDAA). <br/><br/><br/>Eligibility requirements and restrictions apply. Please refer to the <a href="https://www.usbank.com/caas/digital-services-agreement.html">Digital Services Agreement</a> for more information. <br/><br/><br/>Other conditions and restrictions may apply. Terms may change without notice.<br/></span>',
        disclosureList:
            '<ol class="list-style"><li>A transaction includes deposits and other credits, checks paid and other debits, ACH and deposited items, and signature and PIN-based purchases made with a U.S. Bank Business Debit Card. The U.S. Bank Business Debit Card is issued by U.S. Bank National Association, pursuant to a license from Visa U.S.A. Inc.</li><li>Discount applies to business products offered by Deluxe Corporation. Discounts are as follows:<br/> Silver Business Checking Account Package: 50% off first order up to $50<br/>Gold Business Checking Account Package: 50% off first order up to $100<br/>Platinum Business Checking Account Package: 50% off first order up to $100 <br/>Business Essentials: 50% off first order up to $50</li><li>Monthly Maintenance Fee Waiver Options: Gold Business Checking: U.S. Bank Payment Solutions Merchant Banking OR $10,000 average collected balance OR $20,000 combined average collected business deposit balances OR $50,000 combined average collected business deposits and outstanding credit balances. Platinum Business Checking: U.S. Bank Payment Solutions Merchant Banking OR $25,000 average collected balance OR $75,000 combined average collected business deposits and outstanding business credit balances.</li></ol>',
    },
};
